import { ApiClient } from './apiClient'

import { request } from '@/api/request'

export const aojRequest = request('AOJ')
export const datRequest = request('DAT')
export const analyticRequest = request('ANALYTIC')
export const reviewRequest = request('REVIEW')

export const createApiClients = () => {
  return {
    aojClient: new ApiClient(aojRequest),
    analyticClient: new ApiClient(analyticRequest),
    datClient: new ApiClient(datRequest),
    reviewClient: new ApiClient(reviewRequest)
  }
}

export type ApiClients = ReturnType<typeof createApiClients>
